import { DefaultService } from '@/services/DefaultService';


export default class ApiAssClienteSovisApiPartnerService extends DefaultService {
    constructor(http, router, env) {
		super(http, router, env);
	}
    getByIdApiPartner(id) {
        return this._http.get(`${this._env}/apiwebhookautenticacao/getbyidapipartner/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }
    save(obj) {
        return this._http.post(`${this._env}/apiwebhookautenticacao`, obj, this._headers).then(res => {
          return res.body;
            }, err => {
                this.verifyError(err);
                throw err;
            });
    }
}